import type { APIInstance } from "./apiService";
import {
  type Firm,
  type FirmSettingsResponse,
  FirmSettingsResponseSchema,
  type UpdateFirmSettingsRequest,
} from "./firmServiceV2.types";

export class FirmServiceV2 {
  private api: APIInstance;

  constructor(api: APIInstance) {
    this.api = api;
  }

  async getFirmsForUser(): Promise<Firm[]> {
    const response = await this.api.get("/firms");
    const data = response.data || [];
    return data;
  }

  async getFirmSettings(firmId: string): Promise<FirmSettingsResponse> {
    const response = await this.api.get(`/firms/${firmId}/settings`);
    return FirmSettingsResponseSchema.parse(response.data);
  }

  async updateFirmSettings(
    firmId: string,
    request: UpdateFirmSettingsRequest
  ): Promise<FirmSettingsResponse> {
    const response = await this.api.patch(`/firms/${firmId}/settings`, request);
    return FirmSettingsResponseSchema.parse(response.data);
  }
}
